<template>
 <div>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="my-4" color="indigo" dark v-bind="attrs" v-on="on">
          {{itemAction.name}}
        </v-btn>
      </template>
      <v-card outlined :loading="loading" class="showScroll">
        <v-card-text>
            <v-treeview
            v-model="item"
            :items="items"
            selected-color="success"
            @update:active="onUpdate"
            return-object
            open-on-click
            activatable
            transition>
            <!-- :item-key="(itemAction.value)? itemAction.value : 'id'" -->
            <template v-slot:prepend="{ item }">
                <v-icon v-if="item.children" v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"></v-icon>
                <v-icon v-else-if="!item.children" v-text="`mdi-${'folder-network'}`"></v-icon>
                {{ itemText(item) }}
            </template>
            </v-treeview>
        </v-card-text>
      </v-card>
  </v-menu>
  <label v-if="showselected" class="font-weight-bold black--text pl-2">{{ itemAction.name }}: </label>
  <span class="font-weight-bold" v-if="selected"> {{ itemText(selected) }} </span>
 </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    menu: false,
    selected: null,
    showselected: false,
    loading: true,
    open: [],
    items: [],
    item: null
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'departamento_id') {
        return `${item.nombre}`
      }
      return 'No Title'
    },
    cancel () {
      this.menu = false
    },
    send () {
      // this.cancel()
    },
    getDinamicData (url) {
      const token = this.$cookies.get('token')
      axios.get(url, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.items = []
        this.items.push(...response.data)
        this.loading = false
      }).catch(error => {
        console.log('error', error)
        if (error == null) {
        }
      })
    },
    onUpdate (selection) {
      if (selection && selection.length > 0) {
        console.log('selection', selection)
        const item = selection[0]
        this.selected = item
        this.onSuccess({ id: this.itemAction.nameid, data: item[this.itemAction.value] })
        this.cancel()
      } else {
        this.showselected = false
      }
    }
  },
  computed: {},
  watch: {
    selected (val) {
      this.showselected = true
    }
  }
}
</script>

<style scoped>
.showScroll {
  max-height: 450px;
  overflow: auto;
}
</style>
